// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_yQq","cls2":"ImpactHubModal-cls2_bIA ImpactHubModal-cls1_yQq"};